export default __webpack_public_path__ + "static/media/logo.ca75bcc6.svg";